import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import {
  updateEntityRequest,
  receiveEntityResponse,
  receiveUpdatedEntityResponse,
  getEntitiesRequest,
  getEntitiesResponse,
  editEntityRequest,
} from '../EntityActions';

const ENTITY_LIST_NAME = 'homepage_sections';

export function getHomepageSections() {
  return dispatch => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v1/cms/page/home', {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(json => dispatch(getEntitiesResponse(json, ENTITY_LIST_NAME)));
  };
}

export const editHomepageSection = homepageSection => dispatch => {
  dispatch(editEntityRequest(homepageSection));
};

export function addHomepageSection(createHomepageSectionRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/home/create', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(createHomepageSectionRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: 'Story Added' })));
  };
}

export function updateHomepageSection(updatedHomepageSectionRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/home/update', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(updatedHomepageSectionRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveUpdatedEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: 'Story Updated' })));
  };
}
